import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function FullHeightLayout({ className, children }) {
    return (_jsx("div", { className: clsx("flex flex-col", "h-full", "overflow-y-auto", "px-2", className), children: children }));
}
FullHeightLayout.Fixed = function Fixed({ heightClass, className, children }) {
    return (_jsx("div", { className: clsx("w-full", heightClass, className), children: children }));
};
FullHeightLayout.Body = function Body({ className, children }) {
    return (_jsx("div", { className: clsx("grow overflow-auto", "min-h-0", "p-2", className), children: children }));
};
FullHeightLayout.VR = function VDivider({}) {
    return (_jsx("div", { className: "w-[1px] border border-red-200" }));
};
FullHeightLayout.HR = function HDivider({}) {
    return (_jsx("div", { className: "w-full h-1 border-b border-red-200" }));
};
FullHeightLayout.Flex = function Flex({ className, children }) {
    return (_jsx("div", { className: clsx("grow flex flex-col", "overflow-hidden min-h-0", "p-2", className), children: children }));
};
FullHeightLayout.Tab = function Tab({ children }) {
    return (_jsx("div", { className: "flex flex-col h-full", children: children }));
};
//# sourceMappingURL=FullHeightLayout.js.map